import { Agency } from '@/modules/agency/agency';
import { User } from '@/modules/user/user';
import { validateTag } from '@shared/common/data-validators/tag.validator';

export class Tag {

    public static validate(data: any): string[] {
        return validateTag(data);
    }
    public id!: string;
    public label!: string;
    public agencyId!: string;
    public createdAt!: Date;
    public updatedAt!: Date;
    public createdBy?: User;
    public updatedBy?: User;

    public agency?: Agency;

    constructor(opt: any) {
        Object.assign(this, opt);
    }
}
